document.addEventListener('DOMContentLoaded', function () {
  /*
   * =========================================================
   * DESKTOP TABS
   * =========================================================
   */

  const tabContainers = document.querySelectorAll('[data-product-tabs]');

  tabContainers.forEach(function (tabContainer) {
    const tabButtons = tabContainer.querySelectorAll('[data-tab-button]');
    const tabPanels = tabContainer.querySelectorAll('[data-tab-panel]');

    if (!tabButtons.length || !tabPanels.length) {
      return;
    }

    function activateTab(target) {
      tabButtons.forEach(function (button) {
        const isActive = button.dataset.tabTarget === target;

        button.classList.toggle('is-active', isActive);

        button.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );

        button.tabIndex = isActive ? 0 : -1;
      });

      tabPanels.forEach(function (panel) {
        const isActive = panel.dataset.tabPanel === target;

        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateTab(button.dataset.tabTarget);
      });

      /*
       * Keyboard navigation
       */
      button.addEventListener('keydown', function (event) {
        const buttons = Array.from(tabButtons);
        const currentIndex = buttons.indexOf(button);

        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % buttons.length;
        }

        if (event.key === 'ArrowLeft') {
          nextIndex =
            (currentIndex - 1 + buttons.length) %
            buttons.length;
        }

        if (event.key === 'Home') {
          nextIndex = 0;
        }

        if (event.key === 'End') {
          nextIndex = buttons.length - 1;
        }

        if (nextIndex !== currentIndex) {
          event.preventDefault();

          buttons[nextIndex].focus();

          activateTab(
            buttons[nextIndex].dataset.tabTarget
          );
        }
      });
    });
  });


  /*
   * =========================================================
   * MOBILE MAIN ACCORDION
   * Only one main tab can be open at a time
   * =========================================================
   */

  const mobileItems = document.querySelectorAll(
    '.product-information-tabs__mobile-item'
  );

  mobileItems.forEach(function (item) {
    const button = item.querySelector(
      ':scope > .product-information-tabs__mobile-button'
    );

    const content = item.querySelector(
      ':scope > .product-information-tabs__mobile-content'
    );

    if (!button || !content) {
      return;
    }

    button.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      /*
       * Close every other mobile tab first
       */
      mobileItems.forEach(function (otherItem) {
        if (otherItem === item) {
          return;
        }

        const otherButton = otherItem.querySelector(
          ':scope > .product-information-tabs__mobile-button'
        );

        const otherContent = otherItem.querySelector(
          ':scope > .product-information-tabs__mobile-content'
        );

        if (!otherButton || !otherContent) {
          return;
        }

        otherItem.classList.remove('is-open');

        otherButton.setAttribute(
          'aria-expanded',
          'false'
        );

        otherContent.setAttribute(
          'hidden',
          ''
        );
      });


      /*
       * If clicked item was already open,
       * close it.
       */
      if (isOpen) {
        item.classList.remove('is-open');

        button.setAttribute(
          'aria-expanded',
          'false'
        );

        content.setAttribute(
          'hidden',
          ''
        );

        return;
      }


      /*
       * Otherwise open clicked item
       */
      item.classList.add('is-open');

      button.setAttribute(
        'aria-expanded',
        'true'
      );

      content.removeAttribute('hidden');
    });
  });


  /*
   * =========================================================
   * FAQ ACCORDION
   * Only one FAQ can be open at a time
   * =========================================================
   */

  const faqItems = document.querySelectorAll(
    '.product-information-tabs__faq-item'
  );

  faqItems.forEach(function (item) {
    const button = item.querySelector(
      ':scope > .product-information-tabs__faq-question'
    );

    const answer = item.querySelector(
      ':scope > .product-information-tabs__faq-answer'
    );

    if (!button || !answer) {
      return;
    }

    button.addEventListener('click', function () {
      const isOpen =
        button.getAttribute('aria-expanded') === 'true';


      /*
       * Close every other FAQ
       */
      faqItems.forEach(function (otherItem) {
        if (otherItem === item) {
          return;
        }

        const otherButton = otherItem.querySelector(
          ':scope > .product-information-tabs__faq-question'
        );

        const otherAnswer = otherItem.querySelector(
          ':scope > .product-information-tabs__faq-answer'
        );

        if (!otherButton || !otherAnswer) {
          return;
        }

        otherButton.setAttribute(
          'aria-expanded',
          'false'
        );

        otherAnswer.setAttribute(
          'hidden',
          ''
        );
      });


      /*
       * If clicked FAQ was already open,
       * close it.
       */
      if (isOpen) {
        button.setAttribute(
          'aria-expanded',
          'false'
        );

        answer.setAttribute(
          'hidden',
          ''
        );

        return;
      }


      /*
       * Otherwise open clicked FAQ
       */
      button.setAttribute(
        'aria-expanded',
        'true'
      );

      answer.removeAttribute('hidden');
    });
  });
});

//Faq 
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-information-tabs__faq').forEach(function (faq) {
    const questions = faq.querySelectorAll('h3');

    questions.forEach(function (question, index) {
      const answer = question.nextElementSibling;

      if (!answer) return;

      question.classList.add('product-information-tabs__faq-question');
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.setAttribute(
        'aria-expanded',
        index === 0 ? 'true' : 'false'
      );

      answer.classList.add('product-information-tabs__faq-answer');
      answer.hidden = index !== 0;

      function toggleFAQ() {
        const isOpen = question.getAttribute('aria-expanded') === 'true';

        // Close all FAQs
        questions.forEach(function (otherQuestion) {
          const otherAnswer = otherQuestion.nextElementSibling;

          otherQuestion.setAttribute('aria-expanded', 'false');

          if (otherAnswer) {
            otherAnswer.hidden = true;
          }
        });

        // Open clicked FAQ if it was closed
        if (!isOpen) {
          question.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      }

      question.addEventListener('click', toggleFAQ);

      question.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleFAQ();
        }
      });
    });
  });
});